import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { PromosService } from 'app/services';
import { ServiceTypePromotionsComponent } from 'app/components/service-type/service-type-promotions/service-type-promotions.component';

enum PromoDetailTab {
    PromoDetail = 1,
    Mechanics = 2,
    GeoLocation = 3,
    Marketing = 4
}

@Component({
    selector: 'service-type-promotions-detail',
    templateUrl: './service-type-promotions-detail.component.html',
    styleUrls: ['./service-type-promotions-detail.component.scss',
        '../../../../../styles/sidebar.scss'
    ],
    providers: [MessageService]
})

export class ServiceTypePromotionsDetailComponent implements OnInit {
    @Input()
    public showSideBar: boolean = false;

    public promoId: number = 0;
    @Input()
    set _promoId(value: number) {
        if (value > 0) {
            this.promoId = value;
            this.getPromo();
        }
    }

    @Input() public serviceTypePromotionsComponent!: ServiceTypePromotionsComponent;

    @Output() changedShowSideBarEmit = new EventEmitter<boolean>();
    changedShowSideBar(increased: any) {
        this.changedShowSideBarEmit.emit(increased);
    }

    constructor(
        private messageService: MessageService,
        private promosService: PromosService
    ) { }

    public promo: any = null;

    public loading: boolean = false;

    public activeTab: PromoDetailTab = PromoDetailTab.PromoDetail;

    public menuItems: MenuItem[] = [
        {
            label: 'Promo Detail',
            command: (e: any) => this.handleTabChange(PromoDetailTab.PromoDetail)
        },
        {
            label: 'Mechanics',
            command: (e: any) => this.handleTabChange(PromoDetailTab.Mechanics)
        },
        {
            label: 'Geo Location',
            command: (e: any) => this.handleTabChange(PromoDetailTab.GeoLocation)
        },
        {
            label: 'Marketing',
            command: (e: any) => this.handleTabChange(PromoDetailTab.Marketing)
        }
    ];

    ngOnInit(): void {
    }

    public getPromo() {
        this.loading = true;

        const dto = {
            PromoId: this.promoId
        };

        this.promosService.getPromo(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.promo = data.Promo;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    private callMethods() {
        if (this.activeTab === PromoDetailTab.PromoDetail) {
            this.getPromo();
        }
        else if (this.activeTab === PromoDetailTab.Mechanics) {

        }
        else if (this.activeTab === PromoDetailTab.GeoLocation) {

        }
        else if (this.activeTab === PromoDetailTab.Marketing) {

        }
    }

    public handleTabChange(tab: PromoDetailTab) {
        this.activeTab = tab;
        this.callMethods();
    }

    public changePromoActive(promo: any) {
        this.updatePromoIsActive(promo);
    }

    public updatePromoIsActive(promo: any) {
        const dto = {
            PromoId: promo.Id,
            IsActive: promo.IsActive
        };
        this.promosService.updatePromoIsActive(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data updated successfully' });
                this.serviceTypePromotionsComponent.getPromos(0);
            });

    }

    public openEditPromo() {
        //this.serviceTypePromotionsComponent.showModalSideBarAddUpdate(this.promo);
        this.changedShowSideBar(false);
    }

    cancel() {
        this.changedShowSideBar(this.showSideBar);
    }
}
